exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skeleton[data-v-2b598df3] {\n  color: white;\n  display: flex;\n  width: 150px;\n  gap: 12px;\n  align-items: center;\n}\n.skeleton .avatar[data-v-2b598df3] {\n  height: 24px;\n  width: 24px;\n  aspect-ratio: 1/1;\n  border-radius: 9999px;\n  background-color: white;\n}\n.skeleton .text[data-v-2b598df3] {\n  border-radius: 4px;\n  background-color: white;\n  width: 100%;\n  height: 16px;\n}\n.customer[data-v-2b598df3] {\n  width: 150px;\n}\n.wrap[data-v-2b598df3] {\n  word-wrap: break-word;\n}", ""]);

// exports
